
class IEMapService{
    /**
     * @constructor
     * @classdesc 一张图服务基础接口
     * @alias G.service.IEMapService
     * @param opts
     * @param opts.httpRequest {G.base.IHttpRequest} 请求对象
     * @param opts.url {String} 服务地址
     */
    constructor(opts){
        this.opts=opts||{};
    }
}
module.exports = IEMapService;